import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyInterceptors } from './interceptors';
import { JwtHelperService, JwtModule } from '@auth0/angular-jwt';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return localStorage.getItem("token");
        },
      },
    }),
  ],
  providers: [
    MyInterceptors,
    JwtHelperService,
  ],
})
export class CoreModule { }
